import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Declared here rather than in the `tsp-models` submodule: these shapes belong
 * to the admin gateway endpoints alone, and bumping the submodule pointer is a
 * workspace-wide change. Same call the city service makes for `CityQuery`.
 */
export interface CandidateApplySource {
  /** Value that goes into the token and into `/candidate/:source/apply`. */
  source: string;
  /** Row in the `source` table applies from this source are attributed to. */
  sourceId: number;
}

export interface CandidateApplyToken {
  source: string;
  token: string;
}

export interface CandidateApplyTokenVerification {
  valid: boolean;
  source: string | null;
  reason?: string;
}

@Injectable({
  providedIn: 'root',
})
export class M2mService {
  private readonly http = inject(HttpClient);

  public getCandidateApplySources(): Observable<{ sources: CandidateApplySource[] }> {
    return this.http.get<{ sources: CandidateApplySource[] }>('/admin/m2m/candidate-apply/sources');
  }

  public generateCandidateApplyToken(source: string): Observable<CandidateApplyToken> {
    return this.http.post<CandidateApplyToken>('/admin/m2m/candidate-apply/token', { source });
  }

  public verifyCandidateApplyToken(token: string): Observable<CandidateApplyTokenVerification> {
    return this.http.post<CandidateApplyTokenVerification>('/admin/m2m/candidate-apply/token/verify', { token });
  }
}
